<div class="cliente-analise-mercado-cliente-list"
    cdk-scrollable
    infiniteScroll
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000"
    [scrollWindow]="false" 
    (scrolled)="onInfiniteScroll()">

    <sgt-cliente-analise-mercado-cliente-table
        #table
        [clientes]="clientes | async"
        [quantidadeClientes]="list?.quantidadeClientes"
        [total]="list?.total"
        [orderBy]="orderBy"
        (orderByChange)="onOrderByChange($event)"
        [controleQuantidade]="config?.controleQuantidade"
        [controlePeso]="config?.controlePeso"
        [controleValor]="config?.controleValor"
        [isShowClassificaoRAP]="config?.isShowClassificaoRAP"
        [isShowCustomerShare]="config?.isShowCustomerShare"
        (openAnaliseMercado)="openAnaliseMercado($event)"
        (openCliente)="openCliente($event)"
        (preBaixarCliente)="preBaixarCliente($event)"
        (baixarCliente)="baixarCliente($event)"
        (insertCentralCompra)="insertCentralCompra()"
        (editCentralCompra)="editCentralCompra($event)"
        (insertParticipanteCentralCompra)="insertParticipanteCentralCompra($event)">
    </sgt-cliente-analise-mercado-cliente-table>
</div>


<sgt-cliente-analise-mercado-form-modal
    #formModal
    (afterClose)="afterCloseFormModal()">
</sgt-cliente-analise-mercado-form-modal>

<sgt-cliente-analise-mercado-lancamento-form-modal
    #lancamentoFormModal
    (afterSave)="afterSaveLancamento()">
</sgt-cliente-analise-mercado-lancamento-form-modal>

<!-- Cliente Form Modal -->
<sgt-cliente-form-modal
    #clienteFormModal
    (afterEdit)="afterEditCliente()">
</sgt-cliente-form-modal>

<!-- Modal para pré-baixar um cliente -->
<sgt-cliente-carteira-prebaixar-modal
    #clienteCarteiraPreBaixarModal
    [isRepresentante]="isRepresentante"
    (afterInsertPreBaixa)="afterPreBaixarCliente()"
    (afterEditPreBaixa)="afterPreBaixarCliente()">
</sgt-cliente-carteira-prebaixar-modal>

<!-- Modal para baixar um cliente -->
<sgt-cliente-carteira-baixar-modal
    #clienteCarteiraBaixarModal
    [isRepresentante]="isRepresentante"
    (afterInsertBaixa)="afterBaixarCliente()"
    (afterEditBaixa)="afterBaixarCliente()">
</sgt-cliente-carteira-baixar-modal>

<!-- Cliente Central Compra Form Modal -->
<sgt-cliente-form-modal
    #clienteCentralCompraFormModal
    (afterInsert)="afterInsertCentralCompra($event)">
</sgt-cliente-form-modal>


<!-- Modal para atualiar uma central de compras-->
<sgt-cliente-central-compra-form-modal
    #centralCompraFormModal
    (afterSave)="afterSaveCentralCompra($event)">
</sgt-cliente-central-compra-form-modal>

<!-- Modal para adicionar um participante em uma central de compras -->
<sgt-cliente-central-compra-participante-form-insert-modal
    #centralCompraParticipanteFormModal
    (afterSave)="afterSaveCentralCompra($event)">
</sgt-cliente-central-compra-participante-form-insert-modal>